import React, { useState, useEffect } from 'react';
import { Container, Card, Button } from 'react-bootstrap';

const CountryOfOriginTest = () => {
  const [testData, setTestData] = useState(null);

  // Sample test data that mimics the extracted JSON structure
  const sampleData = {
    "case": {
      "case_information": {
        "Case UPC": "000 42238 85275 4",
        "Product Type": "Case"
      }
    },
    "products": [
      {
        "product_id": "1",
        "name": "Goldbears",
        "product_information": {
          "Retail Pkg. UPC": "0 42238 30241 9",
          "Country of Origin": "Germany",
          "Retail Pkg. Dimension (L/DxWxH)": "7.9\" x 5.7\" x 0.5\"",
          "Shelf Life": "24 months",
          "Retail Pkg. Net Wt.": "4oz (113g)",
          "Product Type": "Each"
        }
      },
      {
        "product_id": "2", 
        "name": "Twin Snakes",
        "product_information": {
          "Retail Pkg. UPC": "0 42238 34093 0",
          "Country of Origin": "Turkey",
          "Retail Pkg. Dimension (L/DxWxH)": "7.9\" x 5.7\" x 0.5\"",
          "Shelf Life": "24 months",
          "Product Type": "Each"
        }
      }
    ]
  };

  useEffect(() => {
    setTestData(sampleData);
  }, []);

  const testFieldCategorization = (fieldName) => {
    const lowerFieldName = fieldName.toLowerCase().trim();
    
    // This is the same logic from DynamicForm.js
    const fieldCategoryMapping = {
      microbiological_properties: [
        'total plate count', 'yeast and mold', 'plate count'
      ],
      product_claims_certifications: [
        'organic', 'non-gmo', 'kosher', 'halal', 'certified'
      ],
      physical_chemical_attributes: [
        'ph', 'moisture', 'color', 'texture', 'appearance'
      ],
      nutritional_information: [
        'calories', 'protein', 'fat', 'carbohydrate'
      ]
    };

    // Check for category matches
    for (const [category, keywords] of Object.entries(fieldCategoryMapping)) {
      if (keywords.some(keyword => lowerFieldName.includes(keyword))) {
        return category;
      }
    }

    return null; // Return null if no category match found
  };

  const analyzeFields = () => {
    if (!testData || !testData.products) return;

    console.log('=== FIELD ANALYSIS ===');
    
    testData.products.forEach((product, index) => {
      console.log(`\nProduct ${index + 1}: ${product.name}`);
      console.log('Product Information Fields:');
      
      Object.entries(product.product_information || {}).forEach(([fieldName, fieldValue]) => {
        const category = testFieldCategorization(fieldName);
        console.log(`  - "${fieldName}": "${fieldValue}" -> Category: ${category || 'NONE (stays in product_information)'}`);
        
        if (fieldName === "Country of Origin") {
          console.log(`    *** COUNTRY OF ORIGIN ANALYSIS ***`);
          console.log(`    - Field exists: YES`);
          console.log(`    - Value: "${fieldValue}"`);
          console.log(`    - Should be categorized: ${category || 'NO (stays in product_information)'}`);
          console.log(`    - Should appear in product tabs: YES`);
        }
      });
    });
  };

  return (
    <Container className="mt-4">
      <Card>
        <Card.Header>
          <h4>Country of Origin Field Test</h4>
        </Card.Header>
        <Card.Body>
          <p>This test component analyzes how the Country of Origin field is processed.</p>
          
          <Button onClick={analyzeFields} className="mb-3">
            Analyze Fields in Console
          </Button>

          {testData && (
            <div>
              <h5>Test Data Structure:</h5>
              <div className="mb-3">
                <strong>Products Found:</strong> {testData.products?.length || 0}
              </div>
              
              {testData.products?.map((product, index) => (
                <Card key={index} className="mb-3">
                  <Card.Header>
                    Product {index + 1}: {product.name}
                  </Card.Header>
                  <Card.Body>
                    <h6>Product Information Fields:</h6>
                    <ul>
                      {Object.entries(product.product_information || {}).map(([fieldName, fieldValue]) => (
                        <li key={fieldName} style={{ 
                          color: fieldName === "Country of Origin" ? "red" : "black",
                          fontWeight: fieldName === "Country of Origin" ? "bold" : "normal"
                        }}>
                          <strong>{fieldName}:</strong> {fieldValue}
                          {fieldName === "Country of Origin" && " ← THIS IS THE FIELD WE'RE TESTING"}
                        </li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              ))}
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CountryOfOriginTest;
